export default __webpack_public_path__ + "images/6a917bc1e2fa371e095aab6c5023f2e7-edmelectronic_small.webp";